/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Error_Revision_Not_Found1Inputs */

const vi_cmstools_error_revision_not_found1 = /** @type {(inputs: Cmstools_Error_Revision_Not_Found1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy lần đăng này — tải lại trang.`)
};

/**

* @param {Cmstools_Error_Revision_Not_Found1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_error_revision_not_found1 = /** @type {((inputs?: Cmstools_Error_Revision_Not_Found1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Error_Revision_Not_Found1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_error_revision_not_found1(inputs)
});
export { cmstools_error_revision_not_found1 as "cmsTools_error_revision_not_found" }